const ENDPOINTS = {

  local: {
    contentServer: {
      server: "https://api-beta.library.io",
      tenant: "123D-Circuits"
    },
    collabServer: "https://beta-colab.circuits.io",
    accounts: "https://accounts-staging.autodesk.com",
    routerWebWorker: "./router_worker.min.js",
    copperPourWebWorker: "./copper_pour_worker.min.js",
    eventsAPI: {
      server: "",
      AFC: "CR1ONB"
    },
    mainSite: "https://local.library.io",
    footprintEditor: "https://editor-footprint-local.library.io",
    symbolEditor: "https://editor-symbol-local.library.io",
    packageEditor: "https://editor-package-local.library.io",
    componentEditor: "https://editor-component-local.library.io",
    libraryEditor: "https://editor-library-local.library.io"
  },

  dev: {
      contentServer: {
        server: "https://api-beta.library.io",
        tenant: "123D-Circuits"
      },
      collabServer: "https://beta-colab.circuits.io",
      accounts: "https://accounts-staging.autodesk.com",
      routerWebWorker: "./router_worker.min.js",
      copperPourWebWorker: "./copper_pour_worker.min.js",
      eventsAPI: {
        server: "",
        AFC: "CR1ONB"
      },
      mainSite: "https://dev.library.io",
      footprintEditor: "https://editor-footprint-beta.library.io",
      symbolEditor: "https://editor-symbol-beta.library.io",
      packageEditor: "https://editor-package-beta.library.io",
      componentEditor: "https://editor-component-beta.library.io",
      libraryEditor: "https://editor-library-beta.library.io"
  },

  staging: {
      contentServer: {
        server: "https://api-staging.library.io",
        tenant: "123D-Circuits"
      },
      collabServer: "https://beta-colab.circuits.io",
      accounts: "https://accounts-staging.autodesk.com",
      routerWebWorker: "./router_worker.min.js",
      copperPourWebWorker: "./copper_pour_worker.min.js",
      eventsAPI: {
        server: "",
        AFC: "CR1ON2"
      },
      mainSite: "https://staging.library.io",
      footprintEditor: "https://editor-footprint-staging.library.io",
      symbolEditor: "https://editor-symbol-staging.library.io",
      packageEditor: "https://editor-package-staging.library.io",
      componentEditor: "https://editor-component-staging.library.io",
      libraryEditor: "https://editor-library-staging.library.io",
  },

  production: {
      contentServer: {
        server: "https://api.library.io",
        tenant: "123D-Circuits"
      },
      collabServer: "https://colab.circuits.io",
      accounts: "https://accounts.autodesk.com",
      routerWebWorker: "./router_worker.min.js",
      copperPourWebWorker: "./copper_pour_worker.min.js",
      eventsAPI: {
        server: "",
        AFC: "CR1ON2"
      },
      mainSite: "https://library.io",
      footprintEditor: "https://editor-footprint.library.io",
      symbolEditor: "https://editor-symbol.library.io",
      packageEditor: "https://editor-package.library.io",
      componentEditor: "https://editor-component.library.io",
      libraryEditor: "https://editor-library.library.io"
    }
}

const ENVIRONMENTS = {
  local: 'local',
  dev: 'beta',
  staging: 'beta',
  production: 'production'
}

const LEGACY_CS = {
  local: 'https://contapi-beta.circuits.io',
  dev: 'https://contapi-beta.circuits.io',
  staging: 'https://contapi-staging.circuits.io',
  production: 'https://contapi.circuits.io'
}

function endpoints(local_cs = false) {
  const environment = env()
  const envEndpoints = ENDPOINTS[environment]
  const hostname = window.location.hostname
  if (hostname.endsWith('circuits.io')) {
    envEndpoints.contentServer.server = LEGACY_CS[environment]
  }

  // Embdedded editors get the R13 CS API endpoint from the URL hash (e.g. https://api.library.io/#BASE64URLENCODED)
  // I opted for this, as it is less obvious and makes the URL seems more 'natural'.
  // https://qt-dev.library.io/package-search/index.html#aHR0cHM6Ly9hcGktYmV0YS5saWJyYXJ5LmlvLzEyM2QtY2lyY3VpdHM
  try {
    const contentServerUrl = base64UrlDecode(window.location.hash?.slice(1))
    if (contentServerUrl) {
      const contentServerUrlObj = new URL(contentServerUrl)
      envEndpoints.contentServer.server = contentServerUrlObj.origin
      const tenant = contentServerUrlObj.pathname.replace(/^\/+|\/+$/g, '')
      if (tenant !== '') {
        envEndpoints.contentServer.tenant = tenant
      }
      console.error(`Found content server API URL: ${contentServerUrl}`)
    }
  } catch (err) {
    console.error(`Could not set CS Url.`, err)
  }

  // Local always overrides
  if (local_cs) {
    const local_cs = 'https://api-local.library.io:4431'
    envEndpoints.contentServer.server = local_cs
  }

  console.error(`Using content server URL: ${envEndpoints.contentServer.server}, tenant: ${envEndpoints.contentServer.tenant}`)

  return envEndpoints
}

function editor_options() {
  const queryParameters = {}
  location.search.substr(1).split("&").forEach(function(part) {
    const item = part.split("=")
    queryParameters[item[0]] = decodeURIComponent(item[1])
  })

  // TEMPORARY do not allow edit mode in deploy
  if(queryParameters.mode > 3) queryParameters.mode = 3;

  var editor_options = {
    assetid: queryParameters.assetid || "",
    assetversion: queryParameters.version || "",
    mode: queryParameters.mode || 3,
    hub: queryParameters.hub || null,
    environment: ENVIRONMENTS[env()],
    recording: queryParameters.recording || false,
    disableIpcForking: queryParameters.disableIpcForking || false
  };

  return editor_options
}

function env () {
  let environment
  const hostname = window.location.hostname
  if (hostname.endsWith('local.library.io') || hostname.endsWith('local.circuits.io')) {
    environment = 'local'
  } else
  if (hostname.endsWith('dev.library.io') || hostname.endsWith('beta.library.io') || hostname.endsWith('beta.circuits.io')) {
    environment = 'dev'
  } else
  if (hostname.endsWith('staging.library.io') || hostname.endsWith('staging.circuits.io')) {
    environment = 'staging'
  } else
  if (hostname.endsWith('.library.io') || hostname.endsWith('.circuits.io')) {
    environment = 'production'
  } else {
    throw `Cannot find environment for '${hostname}'!`
  }
  console.log(`hostname: ${hostname}, env: ${environment}`)
  return environment
}

function base64UrlDecode(data) {
  if (!data) return
  let b64 = data.replace(/-/g, '+').replace(/_/g, '/')
  while (b64.length % 4) b64 += '='
  const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0))
  const decoded = new TextDecoder().decode(bytes)
  return decoded
}

const config = { env, editor_options, endpoints }

// support for Eagle.
if (typeof window !== 'undefined')  {
  window.config = config
} else if (typeof global !== 'undefined') {
  global.config = config
}

module.exports = config